import { Box, Flex } from '@fundamentals'

import React from 'react'
import { RegisterItemAttachmentProperty } from '@core/entities/register/RegisterItem'
import { FileTypeIcon } from '@modules/siteBox/components/FileTypeIcon'

type RegisterItemPropertyAttachmentValueProps = {
  registerItemPropertyData: RegisterItemAttachmentProperty<string>
  onAttachmentClick?: () => void
}

export const RegisterItemPropertyAttachmentValue: React.FC<
  RegisterItemPropertyAttachmentValueProps
> = ({ registerItemPropertyData, onAttachmentClick }) => {
  const fileName = registerItemPropertyData.attachment?.siteBoxDocument.name
  const fileFormat =
    registerItemPropertyData.attachment?.siteBoxDocument.currentVersion.format
  const totalAttachments = registerItemPropertyData.totalAttachments
  const additionalCount =
    totalAttachments != null && totalAttachments > 1 ? totalAttachments - 1 : 0

  const handleAttachmentClick = () => {
    if (onAttachmentClick) {
      onAttachmentClick()
    }
  }

  if (!fileName) {
    return <Box sx={{ color: 'text.secondary' }}>-</Box>
  }

  return (
    <Flex
      flexWrap='nowrap'
      gap={1}
      alignItems='center'
      minWidth={0}
      width='100%'
      sx={{ overflow: 'hidden', contain: 'inline-size' }}
    >
      <Flex
        flex='0 1 auto'
        alignItems='center'
        gap={0.5}
        minWidth={0}
        overflow='hidden'
        onClick={handleAttachmentClick}
        sx={{
          bgcolor: 'grey.100',
          border: '1px solid',
          borderColor: 'grey.300',
          borderRadius: 1,
          px: 0.5,
          py: 0.25,
          cursor: onAttachmentClick ? 'pointer' : 'default',
        }}
      >
        <FileTypeIcon
          format={fileFormat}
          sx={{
            color: 'text.disabled',
            flexShrink: 0,
            width: 16,
            height: 16,
          }}
        />
        <Box
          sx={{
            minWidth: 0,
            flex: 1,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            fontSize: 12,
          }}
        >
          {fileName}
        </Box>
      </Flex>

      {additionalCount > 0 && (
        <Box
          flexShrink={0}
          onClick={handleAttachmentClick}
          sx={{
            bgcolor: 'grey.100',
            border: '1px solid',
            borderColor: 'grey.300',
            borderRadius: 1,
            px: 0.5,
            py: 0.25,
            fontSize: 12,
            cursor: 'pointer',
          }}
        >
          + {additionalCount}
        </Box>
      )}
    </Flex>
  )
}
